import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'lynx-game-frame',
    templateUrl: './game-frame.component.html',
    styleUrls: ['./game-frame.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GameFrameComponent {
  @Input() url: string;
  @Output() back = new EventEmitter();

  get gameSource() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  constructor(private domSanitizer: DomSanitizer) {}
}
